import { useLayoutEffect, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { State } from '../reducer';
import { MessagesState, namespace } from './actions';
import { useActions } from '../Actions';
import useToasts from '../components/Toast/hook';

const autoHideDuration = 2000;

const Messages = () => {
    const { removeVisibleMessage } = useActions(namespace);
    const { messages } = useSelector<State, MessagesState>(
        (s) => s[namespace]
    );
    const [message] = messages;

    useLayoutEffect(() => {
        // clear when unmounting this component
        return () => {
            removeVisibleMessage();
        };
    }, [removeVisibleMessage]);

    const { addToast } = useToasts();
    const addToastRef = useRef(addToast);

    useEffect(() => {
        if (message) {
            addToastRef.current({
                message: message.text,
                type: message.severity,
                autoHideDuration: autoHideDuration,
            });
        }
    }, [message]);


    return null;
};

export default Messages;
